import { render, staticRenderFns } from "./clickView.vue?vue&type=template&id=abbe1cc8&scoped=true"
import script from "./clickView.vue?vue&type=script&lang=js"
export * from "./clickView.vue?vue&type=script&lang=js"
import style0 from "./clickView.vue?vue&type=style&index=0&id=abbe1cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abbe1cc8",
  null
  
)

export default component.exports